import en_US from './translations/CarrierLogisticsUIAssets-en-US.puff.json';
import fr_FR from './translations/CarrierLogisticsUIAssets-fr-FR.puff.json';
import it_IT from './translations/CarrierLogisticsUIAssets-it-IT.puff.json';
import es_ES from './translations/CarrierLogisticsUIAssets-es-ES.puff.json';
import en from './en.json';
import flattenObject from '../../utils/flattenObject';
import unflattenObj from '../../utils/unflattenObject';

export const DEFAULT_LOCALE = 'en-US';

export const LOCALES_MESSAGES_MAP = {
  'en-US': en_US,
  'fr-FR': fr_FR,
  'it-IT': it_IT,
  'es-ES': es_ES,
};

export const flattenDefaultLocaleMessages = flattenObject(en);

export const getTranslations = locale => {
  return unflattenObj(LOCALES_MESSAGES_MAP[locale]?.resources, '-');
};
